import React from 'react'

import { TextBody } from '@ally/metronome-ui'
import { Private } from '@ally/private'

import { AccountDetails } from '../../types'
import { maskAccountNumber } from '../../utils/formatter'

interface AccountDetailsProps {
  account: AccountDetails
}

export const PlanAccountNumber: React.FC<AccountDetailsProps> = ({
  account,
}) => {
  if (!account.retirementPlan || !account.retirementPlan.planNumber) return null

  const planNumber = account.retirementPlan.planNumber.slice(-4)
  return (
    <Private as="span">
      <TextBody tag="span" size="sm" weight="bold">
        {account.retirementPlan.planType} IRA Plan Number:{' '}
      </TextBody>
      <TextBody tag="span" size="sm">
        {maskAccountNumber(planNumber)}
      </TextBody>
    </Private>
  )
}
